import React, { Component } from 'react';
import { withTranslation } from 'react-i18next'
import Moment from 'react-moment';

import KonsesjonsforholdPersonMedAndelList from './KonsesjonsforholdPersonMedAndelList.jsx';
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'


class Konsesjonsforhold extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleKonsesjonsforhold = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var konsesjonsforhold = this.props.konsesjonsforhold
        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleKonsesjonsforhold}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title"><Moment local>{konsesjonsforhold.gyldigTil}</Moment></span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('gyldigtil')}</div>
                            <div className="value"><Moment local>{konsesjonsforhold.gyldigTil}</Moment></div>
                        </div>
                        <div className="column">
                            <div className="label">{t('konsesjonsfrihetegenerklaring')}</div>
                            <div className="value">{konsesjonsforhold.konsesjonsfrihetEgenerklaring}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('kjopesum')}</div>
                            <div className="value">{konsesjonsforhold.kjopesum}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('kommunalsaksreferanse')}</div>
                            <div className="value">{konsesjonsforhold.kommunalSaksreferanse}</div>
                        </div>
                    </div>
                </div>
                { konsesjonsforhold.antallPersonerMedAndel > 0 &&
                    <ul>
                        <KonsesjonsforholdPersonMedAndelList konsesjonsforholdId={konsesjonsforhold.konsesjonsforholdId} antall={konsesjonsforhold.antallPersonerMedAndel} token={this.props.token} settings={this.props.settings} />
                    </ul>
                    }
            </li>
        )
    }
}

export default withTranslation('common')(Konsesjonsforhold)